import React from 'react';
import EntityDescriptionHeader from './EntityDescriptionHeader';
import { EntityDescription } from '../../Api/interfaces';

interface Props {
  descriptions: EntityDescription[];
  onTypeClicked?: (type: string) => void;
}
interface State {
  entityDescriptions: EntityDescription[];
  filter: string;
}
export default class EntityDescriptionList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const descriptions = this.props.descriptions.sort((x, y) => {
      const xLink = x.typeName.endsWith('Link');
      const yLink = y.typeName.endsWith('Link');
      if (xLink === yLink) {
        return (x.label > y.label) ? 1 : -1;
      }
      return (xLink) ? 1 : -1;
    });
    this.state = {
      entityDescriptions: descriptions,
      filter: ''
    };
  }

  private inputChangedHandler = (event: any): void => {
    this.setState({ filter: event.target.value });
  };

  public render(): JSX.Element {
    let { entityDescriptions: entities } = this.state;
    const { filter: _f } = this.state;
    if (_f !== '') {
      entities = entities.filter((e) => {
        const filter = _f.toLocaleLowerCase();
        return e.label.toLocaleLowerCase().includes(filter) || e.typeName.includes(filter);
      });
    }
    return (
      <div className="entityListContainer">
        <div className="searchContainer">
          <input className="search" type="text" placeholder="Type entity name..." onChange={this.inputChangedHandler} />
        </div>
        <ul className="entityList">
          {
            entities.map((t) => <EntityDescriptionHeader key={t.typeName} entityType={t} onTypeClicked={this.props.onTypeClicked} />)
          }
        </ul>
      </div>
    );
  }
}